import { createRequest, RequestConfig } from '../../../core/libs/api';

const config: RequestConfig = {
  method: 'get',
  url: '/ws/api/get_order_status',
};

export const getOrderStatusRequest = (id: string) =>
  createRequest({
    url: config.url,
    query: { id },
    method: config.method,
  });
